import { IPostBrandAddRequest } from './../models/requestBrands'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { CommonPostResponse } from '../../../components/models/models'

export class postBrandAddApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/brand/addBrandDetail',
      requesterInfo,
    })
  }

  public async postBrand(request: IPostBrandAddRequest): Promise<CommonPostResponse> {
    return await this.postAsync<CommonPostResponse>(request)
  }
}
